(function(){
"use strict";
function qs(sel,ctx){return (ctx||document).querySelector(sel)}
function qsa(sel,ctx){return Array.prototype.slice.call((ctx||document).querySelectorAll(sel))}

/* ---------- Mobile menu drawer ---------- */
document.addEventListener("click", function(e){
  if(e.target.closest("[data-menu-open]")){
    var d = qs("[data-menu-drawer]"); if(d){ d.classList.add("is-open"); d.setAttribute("aria-hidden","false"); }
  }
  if(e.target.closest("[data-menu-close]")){
    var d2 = qs("[data-menu-drawer]"); if(d2){ d2.classList.remove("is-open"); d2.setAttribute("aria-hidden","true"); }
  }
});

/* ---------- Cart drawer ---------- */
function openCartDrawer(){ var d=qs("[data-cart-drawer]"); if(d){ d.classList.add("is-open"); d.setAttribute("aria-hidden","false"); } }
function closeCartDrawer(){ var d=qs("[data-cart-drawer]"); if(d){ d.classList.remove("is-open"); d.setAttribute("aria-hidden","true"); } }
document.addEventListener("click", function(e){
  if(e.target.closest("[data-cart-open]")){ e.preventDefault(); openCartDrawer(); }
  if(e.target.closest("[data-cart-close]")){ closeCartDrawer(); }
});
document.addEventListener("keydown", function(e){
  if(e.key === "Escape"){ closeCartDrawer(); var d=qs("[data-menu-drawer]"); if(d){d.classList.remove("is-open");d.setAttribute("aria-hidden","true");} }
});

function updateCartCountFromCart(){
  return fetch("/cart.js").then(function(r){return r.json();}).then(function(cart){
    qsa("[data-cart-count]").forEach(function(el){
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? "" : "none";
    });
    return cart;
  });
}

function refreshCartSections(){
  return fetch("/?sections=cart-drawer")
    .then(function(r){ return r.json(); })
    .then(function(data){
      var html = data["cart-drawer"];
      if(!html) return;
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresh = doc.getElementById("cart-drawer");
      var current = document.getElementById("cart-drawer");
      if(fresh && current){
        var wasOpen = current.classList.contains("is-open");
        current.replaceWith(fresh);
        if(wasOpen){ fresh.classList.add("is-open"); fresh.setAttribute("aria-hidden","false"); }
      }
      return updateCartCountFromCart();
    });
}

/* After a line quantity/remove change: refresh drawer + count everywhere;
   on the cart page itself, reload so totals/line items are always exact. */
function afterCartChange(){
  return refreshCartSections().then(function(){
    if(document.body.getAttribute("data-template") === "cart"){ window.location.reload(); }
  });
}

/* Add to cart — progressive enhancement over the native /cart/add form */
document.addEventListener("submit", function(e){
  var form = e.target;
  if(form.matches('form[action*="/cart/add"]')){
    e.preventDefault();
    var btn = qs("[data-add-to-cart]", form);
    if(btn){ btn.disabled = true; }
    var fd = new FormData(form);
    fetch("/cart/add.js", { method:"POST", body: fd, headers: { "Accept":"application/json" } })
      .then(function(r){ return r.json().then(function(body){ return {ok:r.ok, body:body}; }); })
      .then(function(res){
        if(btn){ btn.disabled = !!qs("[data-variant-id-input]", form) && qs("[data-variant-id-input]", form).value ? false : btn.disabled; btn.disabled = false; }
        if(!res.ok){
          alert((res.body && res.body.description) || "No se pudo añadir la pieza a la bolsa.");
          return;
        }
        var added = qs("[data-cart-added-msg]", form);
        if(added){ added.style.display = "flex"; }
        refreshCartSections().then(openCartDrawer);
      })
      .catch(function(){ if(btn) btn.disabled = false; form.submit(); });
  }
});

/* Cart line quantity / remove (drawer + cart page) */
function changeCartLine(key, quantity){
  return fetch("/cart/change.js", {
    method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
    body: JSON.stringify({ id: key, quantity: quantity })
  }).then(function(r){ return r.json(); }).then(function(){ return afterCartChange(); });
}

document.addEventListener("click", function(e){
  var minus = e.target.closest(".js-qty-minus"), plus = e.target.closest(".js-qty-plus"), remove = e.target.closest(".js-cart-remove");
  if(minus || plus){
    var wrap = (minus||plus).closest(".p47-qty");
    var input = wrap.querySelector(".js-qty-input");
    var val = Math.max(0, (parseInt(input.value,10)||1) + (plus ? 1 : -1));
    val = Math.min(val, 9);
    input.value = val;
    input.dispatchEvent(new Event("change", { bubbles:true }));
  }
  if(remove){
    e.preventDefault();
    var key = remove.getAttribute("data-key");
    if(key) changeCartLine(key, 0);
  }
});

document.addEventListener("change", function(e){
  if(e.target.matches(".js-qty-input")){
    var wrap = e.target.closest("[data-qty-field]");
    var key = wrap && wrap.getAttribute("data-key");
    if(key){
      var qty = Math.max(0, parseInt(e.target.value,10)||0);
      changeCartLine(key, qty);
    }
  }
});

/* ---------- Product variant picker ---------- */
(function(){
  var form = qs("#ProductForm");
  if(!form) return;
  var dataScript = qs("[data-variant-json]", form);
  if(!dataScript) return;
  var variants;
  try { variants = JSON.parse(dataScript.textContent); } catch(e){ return; }
  var idInput = qs("[data-variant-id-input]", form);
  var priceEl = qs(".p47-pdp__price");
  var addBtn = qs("[data-add-to-cart]", form);
  var addLabel = qs("[data-add-to-cart-label]", form);
  var mainImg = qs("#MainProductImage");

  function selectedOptions(){
    return qsa("[data-option-index]", form).map(function(group){
      var pressed = qs('.p47-variant__opt[aria-pressed="true"]', group);
      return pressed ? pressed.getAttribute("data-value") : null;
    });
  }
  function findVariant(opts){
    return variants.filter(function(v){
      return (opts[0] == null || v.option1 === opts[0]) && (opts[1] == null || v.option2 === opts[1]) && (opts[2] == null || v.option3 === opts[2]);
    })[0];
  }
  function applyVariant(v){
    if(!v) return;
    if(idInput) idInput.value = v.id;
    if(priceEl){ priceEl.innerHTML = v.compare_at_html ? ("<s>" + v.compare_at_html + "</s>" + v.price_html) : v.price_html; }
    if(addBtn){ addBtn.disabled = !v.available; }
    if(addLabel){ addLabel.textContent = v.available ? "Añadir a la bolsa" : "Agotado"; }
    if(v.featured_image && mainImg){ mainImg.src = v.featured_image; }
    if(window.history && history.replaceState){
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      history.replaceState({}, "", url);
    }
  }
  qsa(".p47-variant__opt", form).forEach(function(btn){
    btn.addEventListener("click", function(){
      qsa(".p47-variant__opt", btn.closest("[data-option-index]")).forEach(function(b){ b.setAttribute("aria-pressed", b === btn ? "true" : "false"); });
      var labEl = qs("[data-selected-value]", btn.closest("[data-option-index]"));
      if(labEl) labEl.textContent = btn.getAttribute("data-value");
      applyVariant(findVariant(selectedOptions()));
    });
  });
  qsa(".p47-pdp__thumb").forEach(function(t){
    t.addEventListener("click", function(){
      qsa(".p47-pdp__thumb").forEach(function(x){ x.classList.remove("is-active"); });
      t.classList.add("is-active");
      if(mainImg) mainImg.src = t.getAttribute("data-full");
    });
  });
})();

/* ---------- Related products (native Shopify recommendations endpoint) ---------- */
(function(){
  var root = qs("#related-products-root");
  if(!root) return;
  var url = root.getAttribute("data-url");
  if(!url) return;
  fetch(url).then(function(r){ return r.text(); }).then(function(html){
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.getElementById("related-products-root");
    if(fresh && fresh.innerHTML.trim()) root.innerHTML = fresh.innerHTML;
  });
})();

/* ---------- Recently viewed (localStorage only — no app/backend needed) ---------- */
(function(){
  var root = qs("#recently-viewed-root");
  if(!root) return;
  var KEY = "p47_recently_viewed";
  var current;
  try { current = JSON.parse(root.getAttribute("data-product-json")); } catch(e){ current = null; }
  var list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || "[]"); if(!Array.isArray(list)) list = []; } catch(e){ list = []; }
  if(current && current.handle){
    list = list.filter(function(p){ return p.handle !== current.handle; });
    list.unshift(current);
    list = list.slice(0, 8);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}
  }
  var exclude = root.getAttribute("data-exclude");
  var toShow = list.filter(function(p){ return p.handle !== exclude; }).slice(0, 4);
  if(toShow.length === 0) return;
  var html = '<div class="p47-section-head"><span class="t-eyebrow">Vistas recientemente</span></div><div class="p47-grid" style="margin-top:22px">' +
    toShow.map(function(p){
      return '<a href="'+p.url+'" class="p47-card"><div class="p47-card__media">' + (p.image ? '<img class="p47-card__img--1" src="'+p.image+'" alt="" loading="lazy">' : "") +
        '</div><div class="p47-card__body"><span class="p47-card__name">'+p.title+'</span><div class="p47-card__row"><span class="p47-card__price">'+p.price+'</span></div></div></a>';
    }).join("") + "</div>";
  root.innerHTML = html;
})();

/* ---------- Collection filters: auto-submit on change (progressive enhancement) ---------- */
document.addEventListener("change", function(e){
  if(e.target.matches("[data-filter-checkbox]")){ e.target.form.submit(); }
});

/* ---------- Address book ---------- */
document.addEventListener("click", function(e){
  if(e.target.closest("[data-toggle-new-address]")){
    var el = qs("#NewAddressForm"); if(el){ el.style.display = el.style.display === "none" ? "block" : "none"; }
  }
  var editBtn = e.target.closest(".js-toggle-edit-address");
  if(editBtn){
    var t = document.getElementById(editBtn.getAttribute("data-target"));
    if(t){ t.style.display = t.style.display === "none" ? "block" : "none"; }
  }
  if(e.target.closest("[data-confirm-delete-address]")){
    if(!confirm("¿Eliminar esta dirección?")){ e.preventDefault(); }
  }
});
})();
